import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../../services/http-client.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../services/website-theme.service';
/**
 * Change Password Component
 */
let ChangePasswordComponent = class ChangePasswordComponent {
    constructor(httpClient, sanitizer, themeService) {
        this.httpClient = httpClient;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.passwordsSame = true;
        this.passwordStrong = false;
        this.password = {};
        this.activeState = 'password';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.showOldPassword = false;
        this.showNewPassword = false;
        this.showNewPasswordAgain = false;
        this.user = JSON.parse(localStorage.getItem('user'));
        this.themeService.getTheme().subscribe((data) => {
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
    }
    ngOnInit() {
    }
    comparePassword() {
        const passRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,64}$/;
        if (passRegex.test(this.password.new) === false) {
            this.passwordStrong = false;
        }
        else {
            this.passwordStrong = true;
        }
        if (this.password.new !== this.password.newAgain) {
            this.passwordsSame = false;
        }
        else {
            this.passwordsSame = true;
        }
    }
    checkStregth() {
        const passRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,64}$/;
        if (passRegex.test(this.password.new) === false) {
            this.passwordStrong = false;
        }
        else {
            this.passwordStrong = true;
        }
    }
    changePassword() {
        this.comparePassword();
        if (this.passwordStrong && this.passwordsSame) {
            this.httpClient.post('user/changepassword', {
                old_password: this.password.old,
                new_password: this.password.newAgain
            }).subscribe((result) => {
                this.activeState = 'passwordChanged';
                this.user.has_password = true;
                localStorage.setItem('user', JSON.stringify(this.user));
                this.httpClient.post('refreshtoken', {
                    refresh_token: localStorage.getItem('refresh_token')
                }).subscribe((data) => {
                });
                setTimeout(function () {
                    this.activeState = 'basic';
                }.bind(this), 3000);
            }, (error) => {
                this.activeState = 'wrong';
                setTimeout(function () {
                    this.activeState = 'password';
                }.bind(this), 3000);
            });
        }
    }
};
ChangePasswordComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
ChangePasswordComponent = __decorate([
    Component({
        selector: 'ecd-change-passwords',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./change-password.component.html")).default
    })
], ChangePasswordComponent);
export { ChangePasswordComponent };
